export enum ChannelEvents {
  OrderNotificationAdded = 'order_notification_added',
  OrderNotificationUpdated = 'order_notification_updated',
  OrderPresenceChange = 'order_presence_change',
  OrderUpdated = 'order_updated',
  QcReportUpdated = 'qc_report_updated'
}
